import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Headshot = () => {
  return <StaticImage src="../images/headshot.JPG" alt="Christopher Leja" />;
};

export default Headshot;
